const init = () => {
  const triggers = document.querySelectorAll('.js-tab-trigger');
  const accordionElements = document.querySelectorAll('.js-tab-body');
  const ACTIVE_CLASS = 'is-active';
  const OPEN_CLASS = 'is-open';

  if (triggers.length === 0) return;

  const handler = (e) => {
    const target = document.getElementById(e.currentTarget.getAttribute('data-target'));

    accordionElements.forEach(element => {
      element.classList.remove(OPEN_CLASS);
    });

    triggers.forEach(trigger => {
      trigger.classList.remove(ACTIVE_CLASS);
    });

    e.currentTarget.classList.add(ACTIVE_CLASS);
    target.classList.add(OPEN_CLASS);
  };

  triggers.forEach(trigger => {
    trigger.addEventListener('click', handler);
  });

};

export default () => {
  init();
};
